module.exports = __webpack_public_path__ + "static/media/Project1_Fig8.7baf3cdf.svg";